// SECURITY: build safe upi:// and wa.me/ deep links from user-supplied data.
//
// Without these helpers, an attacker who controls a settings field (upi_id)
// or an entity field (tenant.ph) can break out of the URL and override
// parameters — e.g. an upi_id of `victim@upi&am=99999&x=` would override
// the amount the tenant is paying.

// Strict UPI VPA pattern: handle@bank
const UPI_VPA_RE = /^[a-zA-Z0-9._-]{2,}@[a-zA-Z][a-zA-Z0-9.-]{1,}$/;
export const isValidUpiId = (id) =>
    typeof id === 'string' && id.length <= 64 && UPI_VPA_RE.test(id.trim());

// Build a UPI deep link with all values URL-encoded and amount coerced.
// Returns null if the upi_id is invalid (caller should fall back to "UPI not configured").
export const buildUpiUrl = ({ upi_id, payee_name, amount, note }) => {
    if (!isValidUpiId(upi_id)) return null;
    const amt = Number(amount);
    if (!isFinite(amt) || amt <= 0) return null;
    const params = new URLSearchParams({
        pa: upi_id.trim(),
        pn: String(payee_name || 'Owner').trim().slice(0, 64),
        am: amt.toFixed(2),
        cu: 'INR',
        tn: String(note || '').slice(0, 80),
    });
    return `upi://pay?${params.toString()}`;
};

// Normalize a phone to E.164-ish digits (no +) for wa.me links. Strict India
// default: 10 digits → prepend 91; otherwise pass digits through up to 15.
export const toWaPhone = (raw) => {
    const digits = String(raw || '').replace(/\D/g, '').slice(0, 15);
    if (!digits) return null;
    if (digits.length === 10 && /^[6-9]/.test(digits)) return '91' + digits;
    return digits;
};

// Build a wa.me URL with the message URL-encoded. Returns null if no phone.
export const buildWaUrl = (rawPhone, text) => {
    const ph = toWaPhone(rawPhone);
    if (!ph) return null;
    return `https://wa.me/${ph}?text=${encodeURIComponent(String(text || ''))}`;
};
